import React from 'react';
import { Box, Text } from '@common-fe/common-fe';

import { Delimiter } from '@/modules/ExpressSetup/styles/ExpressSetupWizard.styles.ts';

interface Props {
  title: string;
  accounts?: string[];
  description: React.ReactNode | string;
  hideDelimiter?: boolean;
  isLastItem?: boolean;
  isPageMode?: boolean;
}

const ContainerItem: React.FC<Props> = ({
  title,
  accounts,
  description,
  isLastItem,
  hideDelimiter,
  isPageMode,
}) => (
  <Box gap="xxxs">
    <Text
      weight={700}
      size="large"
      color="textBody"
      margin={{ bottom: 'xxxs' }}
      style={{ lineHeight: '22px' }}
    >
      {title}
    </Text>
    {accounts?.length ? (
      <Box direction="row" margin={{ bottom: 'xxxs' }}>
        <Text style={{ lineHeight: '20px' }} color="textBody">
          Accounts:{' '}
          <Text weight={700} style={{ lineHeight: '20px' }} color="textBody">
            {accounts.join(', ')}
          </Text>
        </Text>
      </Box>
    ) : null}
    {typeof description === 'string' ? (
      <Text color="textBody" style={{ lineHeight: '20px' }}>
        {description}
      </Text>
    ) : (
      description
    )}
    {!isPageMode && !isLastItem && !hideDelimiter && <Delimiter margin={{ vertical: 'm' }} />}
  </Box>
);

export default ContainerItem;
